/**
 * Copyright (c) 2024 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Sebastian Hartmann <s.hartmann@techdivision.com>
 */

import { googleMapConfig } from '../../Config/GoogleMapConfig';

/**
 * StudioLocator Component Configuration
 * NOTE: If you change the order of the steps or add steps, you have to change the datalayer Event Mapping
 * src/Services/Tracking/DatalayerService.js
 */
export const studioLocatorConfig = {
  content: {
    component: 'StudioLocator',
    params: {
      apiKey: googleMapConfig.apiKey,
    },
  },
};
